module.exports = __webpack_public_path__ + "static/merchants-3ae465a2ca5e345a179caca5cd7b5d5a.png";